// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__thpYa","col":"styles_col__3ujSR"};